import React, { useState, useEffect } from 'react';
import './Hero.css';

const Hero = () => {
  const [text, setText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const [typingSpeed, setTypingSpeed] = useState(150);

  const roles = ['AI/ML Engineer', 'Signal Processing Specialist', 'Applied Researcher', 'Engineering Team Lead'];

  // Determine if a word starts with a vowel sound
  const startsWithVowel = (word) => {
    return /^[aeiouAEIOU]/.test(word);
  };

  const getArticle = () => {
    const i = loopNum % roles.length;
    return startsWithVowel(roles[i]) ? 'an' : 'a';
  };

  useEffect(() => {
    const handleType = () => {
      const i = loopNum % roles.length;
      const fullText = roles[i];

      setText(
        isDeleting
          ? fullText.substring(0, text.length - 1)
          : fullText.substring(0, text.length + 1)
      );

      setTypingSpeed(isDeleting ? 50 : 150);

      if (!isDeleting && text === fullText) {
        setTimeout(() => setIsDeleting(true), 1000);
      } else if (isDeleting && text === '') {
        setIsDeleting(false);
        setLoopNum(loopNum + 1);
      }
    };

    const timer = setTimeout(handleType, typingSpeed);
    return () => clearTimeout(timer);
  }, [text, isDeleting, loopNum, typingSpeed, roles]);

  // Find the nearest scrollable ancestor for an element (fallback for non-window scroll containers)
  const getScrollableParent = (el) => {
    if (!el) return document.scrollingElement || document.documentElement;
    let parent = el.parentElement;
    const isScrollable = (node) => {
      const style = window.getComputedStyle(node);
      const overflowY = style.overflowY;
      return node.scrollHeight > node.clientHeight && (overflowY === 'auto' || overflowY === 'scroll');
    };
    while (parent && parent !== document.body) {
      if (isScrollable(parent)) return parent;
      parent = parent.parentElement;
    }
    return document.scrollingElement || document.documentElement;
  };

  const smoothScrollTo = (id) => {
    const element = document.getElementById(id);
    if (!element) {
      // helpful debug output for development
      // eslint-disable-next-line no-console
      console.warn(`smoothScrollTo: no element found with id='${id}'`);
      return;
    }

    const parent = getScrollableParent(element);

    if (parent === document.scrollingElement || parent === document.documentElement) {
      const top = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top, behavior: 'smooth' });
    } else {
      const top = element.getBoundingClientRect().top - parent.getBoundingClientRect().top + parent.scrollTop;
      parent.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <p className="hero-greeting">Hi, I'm</p>
            <h1 className="hero-name">Noam Janco</h1>
            <div className="hero-role">
              <span className="static-text">I'm {getArticle()} </span>
              <span className="dynamic-text">{text}</span>
              <span className="cursor">|</span>
            </div>
            <p className="hero-description">
              AI/ML and signal processing engineer with 12+ years across research and product. Published author and
              U.S. patent holder. I develop learning algorithms and signal‑processing pipelines, ranging from deep
              neural networks to real‑time implementations. Previously at General Motors and in Unit 81.
            </p>
            <div className="hero-buttons">
              <button 
                className="btn btn-primary"
                onClick={() => smoothScrollTo('projects')}
              >
                View My Work
              </button>
              <button 
                className="btn btn-secondary"
                onClick={() => smoothScrollTo('contact')}
              >
                Get In Touch
              </button>
              <a
                className="btn btn-secondary"
                href="/NoamJancoCV2023_2.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                View Resume
              </a>
            </div>
          </div>
        </div>
        <div className="hero-bg">
          <div className="gradient-orb orb-1"></div>
          <div className="gradient-orb orb-2"></div>
          <div className="gradient-orb orb-3"></div>
        </div>
      </div>
      <div className="scroll-indicator">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
